import { useEffect } from 'react';

import { __CLIENT_SIDE__ } from '@constants/env';
import PersonalService from '@services/PersonalService';
import { useStores } from '@models/RootStore/RootStore';

declare const opix: (eventName: string, publicationId: string, customData: any) => void;

export const useAddView = (activityId: string) => {
  const { UserStore } = useStores();

  useEffect(() => {
    if (__CLIENT_SIDE__)
      if (UserStore.hasLoaded) {
        if (UserStore.isAuthenticated) {
          PersonalService.addView(activityId);
        }
      } else {
        opix('event', 'View', {
          publication: activityId,
        });
      }
  }, [activityId, UserStore.isAuthenticated, UserStore.hasLoaded]);
};
